import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { StudentUploadComponent } from './student-upload/student-upload.component';
import { StudentAdminStatusComponent } from './student-admin-status/student-admin-status.component';
import { StudentAdmissionDetailsComponent } from './student-admission-details/student-admission-details.component';
import { SummaryReportComponent } from './summary-report/summary-report.component';
import { IssueTCComponent } from './issue-tc/issue-tc.component';
import { StudentTCCountReportComponent } from './student-tccount-report/student-tccount-report.component';
import { StudentPromotionComponent } from './student-promotion/student-promotion.component';
import { StudentIDCardComponent } from './student-idcard/student-idcard.component';
import { SpecialAchievementComponent } from './special-achievement/special-achievement.component';
import { CounsellingRecordsComponent } from './counselling-records/counselling-records.component';
import { DisciplinaryRecordsComponent } from './disciplinary-records/disciplinary-records.component';
import { StudentCategoryReportComponent } from './student-category-report/student-category-report.component';
import { PrintStudentProfileComponent } from './print-student-profile/print-student-profile.component';
import { StudentListingReportComponent } from './student-listing-report/student-listing-report.component';
import { PrintTCComponent } from './print-tc/print-tc.component';
import { IssueTCListPrintComponent } from './issue-tclist-print/issue-tclist-print.component';
import { PrintIdCardComponent } from './print-id-card/print-id-card.component';
import { AdmissionReportComponent } from './admission-report/admission-report.component';
import { StudentDetailsComponent } from './student-details/student-details.component';
import { LeaveComponent } from './leave/leave.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { StudentfeebookuploadComponent } from './studentfeebookupload/studentfeebookupload.component';



const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'studentupload', component: StudentUploadComponent, pathMatch: 'full' },
      { path: 'studentfeebookupload', component: StudentfeebookuploadComponent, pathMatch: 'full' },
      { path: 'studentadminstatus', component: StudentAdminStatusComponent, pathMatch: 'full' },
      { path: 'studentadmissiondetails', component: StudentAdmissionDetailsComponent, pathMatch: 'full' },
      { path: 'summaryreport', component: SummaryReportComponent, pathMatch: 'full' },
      { path: 'issuetc', component: IssueTCComponent, pathMatch: 'full' },
      { path: 'studenttccountreport', component: StudentTCCountReportComponent, pathMatch: 'full' },
      { path: 'studentpromotion', component: StudentPromotionComponent, pathMatch: 'full' },
      { path: 'studentidcard', component: StudentIDCardComponent, pathMatch: 'full' },
      { path: 'specialachievement', component: SpecialAchievementComponent, pathMatch: 'full' },
      { path: 'counsellingrecords', component: CounsellingRecordsComponent, pathMatch: 'full' },
      { path: 'disciplinaryrecords', component: DisciplinaryRecordsComponent, pathMatch: 'full' },
      { path: 'studentcategoryreport', component: StudentCategoryReportComponent, pathMatch: 'full' },
      { path: 'studentadmissionreport', component: AdmissionReportComponent, pathMatch: 'full' },
      { path: 'student-details', component: StudentDetailsComponent, pathMatch: 'full' },
      { path: 'leave', component: LeaveComponent, pathMatch: 'full' },
       { path: 'appointment', component: AppointmentComponent, pathMatch: 'full' },

    ]
  },
  {
    path: '',
    
    children: [
      { path: 'printstudentprofile', component: PrintStudentProfileComponent, pathMatch: 'full' },
      { path: 'studentlistingreport', component: StudentListingReportComponent, pathMatch: 'full' },
      { path: 'printtc', component: PrintTCComponent, pathMatch: 'full' },
      { path: 'issuetclistprint', component: IssueTCListPrintComponent, pathMatch: 'full' },
      { path: 'printidcard', component: PrintIdCardComponent, pathMatch: 'full' },
     ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentRoutingModule { }
